import React from 'react';

import { Box, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { TextBlock } from '@bcp-nextgen-dx-component-factory/design-system';
import { Tooltip } from '@components';

import { SimulationValuesDescriptionProps } from './simulationValuesDescription';
import { useSimulationValuesDescription } from './simulationValuesDescription.helper';

export const SimulationValuesDescriptionAb: React.FC<SimulationValuesDescriptionProps> = (
	props: SimulationValuesDescriptionProps
) => {
	const { currency = '%', label, promoValue, value, decimalScale = 3, labelNote, tooltip } = props;

	const { currentView } = useSimulationValuesDescription(props);

	return (
		<Box styles={{ flexDirection: 'column' }}>
			<Box styles={{ columnGap: '4px' }}>
				<Typography
					colorToken="secondary-light"
					appearance={`microcopy-${currentView === 'smallView' ? '75' : '100'}-06`}
				>
					{currentView === 'smallView' ? label.toUpperCase() : label}
				</Typography>
				{tooltip && <Tooltip title={tooltip.title} content={tooltip.content} />}
			</Box>
			{labelNote && (
				<Typography
					textCase={'lower'}
					colorToken="secondary-light"
					appearance={`microcopy-${currentView === 'smallView' ? '75' : '100'}-06`}
				>
					{labelNote}
				</Typography>
			)}
			{typeof value === 'number' && (
				<TextBlock.Currency
					size={currentView === 'smallView' ? 'small' : 'medium'}
					floatValue={value}
					decimalScale={decimalScale}
					currency={currency}
					fontWeight={'extraStrong'}
				></TextBlock.Currency>
			)}
			{typeof value === 'string' && (
				<Typography
					colorToken="primary-light"
					appearance={currentView === 'smallView' ? 'headline-75-03' : 'headline-100-01'}
				>
					{value}
				</Typography>
			)}
			{typeof value === 'number' && promoValue && promoValue !== value && (
				<TextBlock.Percentage
					size={'small'}
					floatValue={promoValue}
					decimalScale={decimalScale}
					fontWeight={'semiStrong'}
					strikeThrough
					variant="light"
				/>
			)}
		</Box>
	);
};
